import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { style: {"text-align":"left"} }
const _hoisted_2 = { key: 0 }

import { getProcessHistory, getProcessHistoryList } from '@/api/workflow_process';
import { onMounted, reactive, ref } from 'vue'
import { formatDateTime } from "@/components/ts/components";

export default /*#__PURE__*/_defineComponent({
  __name: 'processhHistory',
  props: {
    patientId: {
        type: String,
        default: ''
    }
},
  setup(__props) {

const props = __props;



const data = reactive({
    timeLineOption: [],
    timeItemOption: [{
        activityId:'',
        activityName:'',
        activityType:'',
        startTime:'',
        activityTypeName:'',
        taskAssigneeName:''
    }],
})
const activeKey = ref(['0']);

onMounted(() => {
    console.log('流程历史', props.patientId);
    getProcessHistoryList(props.patientId).then((res: any) => {
        console.log(res);
        data.timeLineOption = res;
        onTimeLine('0');
    })
})

const onTimeLine = (id: string) => {
    if(id){
        getProcessHistory(Object.values(data.timeLineOption[id])[0].id).then((res: any) => {
            console.log(res);
            data.timeItemOption = res
        })
    }
}


return (_ctx: any,_cache: any) => {
  const _component_a_timeline_item = _resolveComponent("a-timeline-item")!
  const _component_a_timeline = _resolveComponent("a-timeline")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_collapse, {
      activeKey: activeKey.value,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event)),
      accordion: "",
      onChange: onTimeLine
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.timeLineOption, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_collapse_panel, { key: index }, {
            header: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (value, key, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(key) + " " + _toDisplayString(typeof (value.creationDate) == 'string' ? value.creationDate :
                            _unref(formatDateTime)(value.creationDate)), 1))
              }), 128))
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_card, { bordered: false }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_timeline, {
                    mode: "left",
                    reverse: true
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.timeItemOption, (it) => {
                        return (_openBlock(), _createBlock(_component_a_timeline_item, {
                          key: it.activityId
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                              _createElementVNode("h3", null, _toDisplayString(it.activityName), 1),
                              _createElementVNode("p", null, _toDisplayString(_unref(formatDateTime)(it.startTime)), 1),
                              _createElementVNode("p", null, "任务类型: " + _toDisplayString(it.activityTypeName), 1),
                              (it.activityType == 'TASK_USER_TASK')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_2, "执行人: " + _toDisplayString(it.taskAssigneeName), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["activeKey"])
  ]))
}
}

})